import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";

import { NavLink } from "react-router-dom";
import { useState, React, useEffect, useRef, useContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Switch from "react-bootstrap-switch";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import SelectComponent from "components/Utils/select.js";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import { useTranslation } from "react-i18next";
import { poeProfile } from "data/subscribers.js";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const ProfileEdit = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  let formError = false;

  const [name, setName] = useState(location.state?.name ?? "");
  const [id, setId] = useState(location.state?.id ?? "");

  const [bandwidths, setBandwidths] = useState([]);
  const [selectedBandwidth, setSelectedBandwidth] = useState(null);
  const [selectedPoe, setSelectedPoe] = useState("enable");
  const [mode, setMode] = useState(location.state ? location.state.mode : "");
  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["installations.site.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  useEffect(() => {
    if (mode == "edit") {
      fetchEditData();
    } else if (mode == "create") {
      fetchCreateData();
    }
  }, [mode]);

  const [values, setValues] = useState({
    name: "",
    vlan: "",
    remapped_vid: "",
    endpoint_tagging: false,
    double_tagging: false,
    trunk_mode: false,
    allowed_tagged_vlan: "",
    bandwidth: "",
    vlan2: "",
    endpoint_tagging_2: false,
    allowed_tagged_vlan_2: "",
    s_vlan_outer_tag: 0,
    endpoint_name_formula: "{ROOM}",
    subscriber_name_formula: "{ROOM}",
    poe: false,
  });

  const [states, setStates] = useState({
    name: "",
    vlan: "",
    remapped_vid: "",
    endpoint_tagging: "",
    double_tagging: "",
    trunk_mode: "",
    allowed_tagged_vlan: "",
    bandwidth: "",
    vlan2: "",
    endpoint_tagging_2: "",
    allowed_tagged_vlan_2: "",
    s_vlan_outer_tag: "",
    endpoint_name_formula: "",
    subscriber_name_formula: "",
    poe: "",
  });

  const setDefaultPoe = (defaultValue) => {
    poeProfile.forEach((item) => {
      if (item.value == defaultValue) {
        setSelectedPoe(item);
        setValues((prevState) => ({
          ...prevState,
          ["poe"]: defaultValue,
        }));
      }
    });
  };

  const setDefaultBandwidth = (list, defaultValue) => {
    var found = false;

    if (defaultValue == "" || !defaultValue) {
      defaultValue = "0";
    }

    list.forEach((item) => {
      if (defaultValue && item.value == defaultValue) {
        setSelectedBandwidth(item);
        setValues((prevState) => ({
          ...prevState,
          ["bandwidth"]: item.value,
        }));
        found = true;
      }
    });
    if (!found) {
      setSelectedBandwidth(null);
      setValues((prevState) => ({
        ...prevState,
        ["bandwidth"]: "",
      }));
    }
  };

  const fetchCreateData = () => {
    fetch("/api/v1/profile/create", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        // Manage Bandwidth List
        var bandwidthList = [
          { value: "0", label: "Unthrottled" },
          ...actualData.data.bandwidths,
        ];
        setBandwidths(bandwidthList);
        setDefaultBandwidth(bandwidthList);

        setDefaultPoe(false);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const fetchEditData = () => {
    fetch("/api/v1/profile/edit", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        profileId: id,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setName(actualData.data.profile.name);
        setValues((prevState) => ({
          ...prevState,
          ["name"]: actualData.data.profile.name,
          ["double_tagging"]: actualData.data.profile.doubleTags,
          ["trunk_mode"]: actualData.data.profile.trunkMode,
          ["endpoint_tagging"]: actualData.data.profile.endpointTagging,
          ["endpoint_tagging_2"]: actualData.data.profile.endpointTagging2,
          ["vlan"]: actualData.data.profile.vlan,
          ["vlan2"]: actualData.data.profile.vlan2,
          ["poe"]: actualData.data.profile.poeModeCtrl,
          ["remapped_vid"]: actualData.data.profile.remappedVID,
          ["s_vlan_outer_tag"]: actualData.data.profile.outerTag,
          ["allowed_tagged_vlan"]: actualData.data.profile.allowedTaggedVlan,
          ["allowed_tagged_vlan_2"]: actualData.data.profile.allowedTaggedVlan2,
          ["endpoint_name_formula"]:
            actualData.data.profile.endpointNameFormula,
          ["subscriber_name_formula"]:
            actualData.data.profile.subscriberNameFormula,
        }));

        setDefaultPoe(actualData.data.profile.poeModeCtrl);

        // Manage Bandwidth List
        var bandwidthList = [
          { value: "0", label: "Unthrottled" },
          ...actualData.data.bandwidths,
        ];
        setBandwidths(bandwidthList);
        setDefaultBandwidth(bandwidthList, actualData.data.profile.bandwidth);
      })
      .catch((err) => {
        console.log(err);
        console.log(err.message);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSwitchChange = (e) => {
    const { props, state } = e;

    setValues({
      ...values,
      [props.name]: state.value,
    });
  };

  const handleTrunkChange = (e) => {
    const { props, state } = e;

    setValues({
      ...values,
      [props.name]: state.value,
      ["allowed_tagged_vlan"]: "",
      ["allowed_tagged_vlan_2"]: "",
    });
  };

  const handleBandwidthChange = (option) => {
    setValues({
      ...values,
      ["bandwidth"]: option.value.value,
    });
    setSelectedBandwidth(option);
  };

  const handlePoeChange = (option) => {
    setValues({
      ...values,
      ["poe"]: option.value.value,
    });
    setSelectedPoe(option);
  };

  const validateField = (field) => {
    let status = "";
    if (values[field] === "") {
      status = "This field is required";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const validateVlan = (field) => {
    let status = "";
    if (values[field] < 3 || values[field] > 4094) {
      status = "VLAN must be an integer value between 3 and 4094";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    formError = false;

    setStates({
      ...states,
      ["name"]: validateField("name"),
      ["vlan"]: validateVlan("vlan"),
      ["s_vlan_outer_tag"]: values["double_tagging"]
        ? validateVlan("s_vlan_outer_tag")
        : "",
      ["bandwidth"]: validateField("bandwidth"),
      ["endpoint_name_formula"]: validateField("endpoint_name_formula"),
      ["subscriber_name_formula"]: validateField("subscriber_name_formula"),
    });

    if (!formError) {
      postData();
    }
  };

  const postData = () => {
    setShowLoading(true);

    // Prepare Url and Api Method
    let apiUrl = "/api/v1/profile/create";
    let apiMethod = "POST";
    let headers = {
      "Content-Type": "application/json",
      sessionId: sessionStorage.getItem("sessionId"),
    };
    if (mode == "edit") {
      apiUrl = "/api/v1/profile/edit";
      apiMethod = "PUT";
      headers = {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        profileId: id,
      };
    }

    // Call the API
    fetch(apiUrl, {
      method: apiMethod,
      headers: headers,

      body: JSON.stringify({
        name: values.name,
        description: values.description,
        vlan: values.vlan,
        remapped_vid: values.remapped_vid,
        endpoint_tagging: values.endpoint_tagging,
        double_tagging: values.double_tagging,
        trunk_mode: values.trunk_mode,
        allowed_tagged_vlan: values.allowed_tagged_vlan,
        bandwidth: values.bandwidth,
        vlan2: values.vlan2,
        endpoint_tagging_2: values.endpoint_tagging_2,
        allowed_tagged_vlan_2: values.allowed_tagged_vlan_2,
        endpoint_name_formula: values.endpoint_name_formula,
        subscriber_name_formula: values.subscriber_name_formula,
        outerTag: values.s_vlan_outer_tag,
        mode: mode,
        poe: values.poe,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == 400) {
          if (actualData.error_code) {
            setErrorMsg(actualData.error_code);
          } else {
            setErrorMsg(actualData.error ? [actualData.error] : [" "]);
          }

          toast.error(
            mode == "create"
              ? "A problem occured while creating the profile"
              : "A problem occured while editing the profile",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          setErrorMsg([]);
          toast.success(
            mode == "create"
              ? "Profile created successfully"
              : "Profile edited successfully",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );

          if (mode == "create") {
            resetForm();
          } else {
            // Reset the params flag with the "new" name
            setName(values.name);
          }
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const resetForm = () => {
    setValues({
      ...values,
      ["name"]: "",
      ["vlan"]: 0,
      ["remapped_vid"]: 0,
      ["endpoint_tagging"]: false,
      ["double_tagging"]: false,
      ["trunk_mode"]: false,
      ["allowed_tagged_vlan"]: "",
      ["bandwidth"]: "",
      ["vlan2"]: 0,
      ["endpoint_tagging_2"]: false,
      ["allowed_tagged_vlan_2"]: "",
      ["s_vlan_outer_tag"]: 0,
      ["endpoint_name_formula"]: "{ROOM}",
      ["subscriber_name_formula"]: "{ROOM}",
      ["poe"]: false,
    });

    setSelectedBandwidth(null);

    fetchCreateData();
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <Breadcrumb>
                    <BreadcrumbItem>
                      <NavLink
                        to={{
                          pathname: "/admin/dashboard",
                        }}
                      >
                        <FontAwesomeIcon icon={faHome} />
                      </NavLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                      <NavLink
                        to={{
                          pathname: "/admin/installations/profile/list",
                        }}
                      >
                        Profiles
                      </NavLink>
                      {name ? <i>&lt;{name}&gt;</i> : ""}
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                      {mode == "create" ? "Create" : ""}
                      {mode == "edit" ? "Edit" : ""}
                    </BreadcrumbItem>
                  </Breadcrumb>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">
                    {t(
                      "profiles.edit.title.information.t." +
                        sessionStorage.getItem("bundleType"),
                      "Profile Information",
                    )}
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  {errorMsg.length > 0 ? (
                    <div
                      style={{
                        backgroundColor: "#FFC0A4",
                        border: "1px solid #ef8157",
                        color: "#66615b",
                        paddingTop: "15px",
                        marginBottom: "15px",
                      }}
                    >
                      <ul>
                        {errorMsg.map((d, index) => (
                          <li key={index}>{d}</li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}

                  <Row>
                    <Col>
                      <label>Name</label>
                      <FormGroup
                        className={
                          states["name"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          placeholder="Enter name"
                          type="text"
                          name="name"
                          onChange={handleInputChange}
                          value={values ? values.name : ""}
                        />
                        <label className="error">{states["name"]}</label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <span style={{ display: "none" }}>
                        <label>
                          Endpoint Name Formula &nbsp;
                          <a className="vmElementEndpoint">
                            <FontAwesomeIcon icon={faInfoCircle} />
                          </a>
                          <ReactTooltip
                            anchorSelect=".vmElementEndpoint"
                            place="top"
                            style={{ textAlign: "left", zIndex: "100" }}
                          >
                            The formula can contain the following variables:{" "}
                            <br />
                            <br />
                            &#123;CODE&#125; - The hotels's code
                            <br />
                            &#123;GAM&#125; - The GAM's system name
                            <br />
                            &#123;ROOM&#125; - The room ID
                            <br />
                            &#123;HOTEL&#125; - Hotel name
                          </ReactTooltip>
                        </label>
                        <FormGroup
                          className={
                            states["endpoint_name_formula"].length !== 0
                              ? "has-danger"
                              : ""
                          }
                        >
                          <Input
                            placeholder="Enter endpoint name formula"
                            type="text"
                            name="endpoint_name_formula"
                            onChange={handleInputChange}
                            value={values ? values.endpoint_name_formula : ""}
                          />
                          <label className="error">
                            {states["endpoint_name_formula"]}
                          </label>
                        </FormGroup>
                      </span>
                    </Col>
                    <Col>
                      <span style={{ display: "none" }}>
                        <label>
                          Subscriber Name Formula &nbsp;
                          <a className="vmElementSubscriber">
                            <FontAwesomeIcon icon={faInfoCircle} />
                          </a>
                          <ReactTooltip
                            anchorSelect=".vmElementSubscriber"
                            place="top"
                            style={{ textAlign: "left", zIndex: "100" }}
                          >
                            The formula can contain the following variables:{" "}
                            <br />
                            <br />
                            &#123;CODE&#125; - The hotels's code
                            <br />
                            &#123;GAM&#125; - The GAM's system name
                            <br />
                            &#123;ROOM&#125; - The room ID
                            <br />
                            &#123;HOTEL&#125; - Hotel name
                          </ReactTooltip>
                        </label>
                        <FormGroup
                          className={
                            states["subscriber_name_formula"].length !== 0
                              ? "has-danger"
                              : ""
                          }
                        >
                          <Input
                            placeholder="Enter subscriber name formula"
                            type="text"
                            name="subscriber_name_formula"
                            onChange={handleInputChange}
                            value={values ? values.subscriber_name_formula : ""}
                          />
                          <label className="error">
                            {states["subscriber_name_formula"]}
                          </label>
                        </FormGroup>
                      </span>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Row>
                <Col>
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">
                        Service 1 Configuration (Port #1)
                      </CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>Trunk Mode</label>
                          <FormGroup>
                            <Switch
                              name="trunk_mode"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleTrunkChange}
                              value={values["trunk_mode"] ? true : false}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>
                            Double Tagging
                          </label>
                          <FormGroup>
                            <Switch
                              name="double_tagging"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={values["double_tagging"]}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>
                            Endpoint Tagging
                          </label>
                          <FormGroup>
                            <Switch
                              name="endpoint_tagging"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={values["endpoint_tagging"] ? true : false}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        {values["double_tagging"] ? (
                          <>
                            <Col>
                              <label>S-VLAN (Outer Tag)</label>
                              <FormGroup
                                className={
                                  states["s_vlan_outer_tag"].length !== 0
                                    ? "has-danger"
                                    : ""
                                }
                              >
                                <Input
                                  type="number"
                                  name="s_vlan_outer_tag"
                                  onChange={handleInputChange}
                                  value={values ? values.s_vlan_outer_tag : 0}
                                />
                                <label className="error">
                                  {states["s_vlan_outer_tag"]}
                                </label>
                              </FormGroup>
                            </Col>
                          </>
                        ) : (
                          ""
                        )}
                        <Col>
                          <label>
                            {values["double_tagging"]
                              ? "C-VLAN (Inner Tag)"
                              : "VLAN"}
                          </label>
                          <FormGroup
                            className={
                              states["vlan"].length !== 0 ? "has-danger" : ""
                            }
                          >
                            <Input
                              type="number"
                              name="vlan"
                              onChange={handleInputChange}
                              value={values ? values.vlan : 0}
                            />
                            <label className="error">{states["vlan"]}</label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <label>Remapped VID</label>
                          <FormGroup
                            className={
                              states["remapped_vid"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="number"
                              name="remapped_vid"
                              onChange={handleInputChange}
                              value={values ? values.remapped_vid : 0}
                            />
                            <label className="error">
                              {states["remapped_vid"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label>Allowed:Remapped Tagged VLANs</label>
                          <FormGroup
                            className={
                              states["allowed_tagged_vlan"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="allowed_tagged_vlan"
                              onChange={handleInputChange}
                              disabled={values["trunk_mode"]}
                              value={values ? values.allowed_tagged_vlan : ""}
                            />
                            <label className="error">
                              {states["allowed_tagged_vlan"]}
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <SelectComponent
                            label="PoE"
                            fieldName={"poe"}
                            array={poeProfile}
                            stateValue={states["poe"]}
                            onChange={(option) => {
                              handlePoeChange(option);
                            }}
                            selectedOption={selectedPoe}
                          />
                        </Col>
                        <Col>
                          <SelectComponent
                            label="Bandwidth"
                            fieldName={"bandwidth"}
                            array={bandwidths}
                            stateValue={states["bandwidth"]}
                            onChange={(option) => {
                              handleBandwidthChange(option);
                            }}
                            selectedOption={selectedBandwidth}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">
                        Service 2 Configuration (Port #2)
                      </CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>
                            Endpoint Tagging
                          </label>
                          <FormGroup>
                            <Switch
                              name="endpoint_tagging_2"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={
                                values["endpoint_tagging_2"] ? true : false
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <label>VLAN</label>
                          <FormGroup
                            className={
                              states["vlan2"].length !== 0 ? "has-danger" : ""
                            }
                          >
                            <Input
                              type="number"
                              name="vlan2"
                              onChange={handleInputChange}
                              value={values ? values.vlan2 : 0}
                            />
                            <label className="error">{states["vlan2"]}</label>
                          </FormGroup>
                        </Col>
                      </Row>{" "}
                      <Row>
                        <Col>
                          <label>Allowed:Remapped Tagged VLANs</label>
                          <FormGroup
                            className={
                              states["allowed_tagged_vlan_2"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="allowed_tagged_vlan_2"
                              onChange={handleInputChange}
                              disabled={values["trunk_mode"]}
                              value={values ? values.allowed_tagged_vlan_2 : ""}
                            />
                            <label className="error">
                              {states["allowed_tagged_vlan_2"]}
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button className="btn-round" color="info" type="submit">
                    Submit
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default ProfileEdit;
